import React, { type ReactNode } from 'react';
import { PageHeader, type PageHeaderProps } from './PageHeader';
import { useGetClosestHandle } from './routing/useGetClosestHandle';

interface PageLayoutProps {
	className?: string;
	homeLink?: string;
	children: ReactNode;
	pageHeader: PageHeaderProps;
}

export function PageLayout({ className, pageHeader, homeLink, children }: PageLayoutProps) {
	//const viewPortRef = useScrollIntoView('patient-header');
	const routeHandle = useGetClosestHandle<{ disableBreadCrumb?: boolean }>();
	return (
		<div className="flex flex-1 flex-col overflow-hidden">
			<PageHeader {...pageHeader} />
			<main className="flex-1 flex-col overflow-y-auto p-6">{children}</main>
		</div>
	);
}
